import { createContext, useContext } from 'react';

export type ResizableColumnsContextValue = {
  /**
   * The group's clock, so a column's edge shadow eases over the same time as the width it is
   * reporting on. Absent where the group was given no `duration`.
   */
  duration?: string;
};

export const ResizableColumnsContext =
  createContext<ResizableColumnsContextValue>({});

/**
 * The `ResizableColumns` a column is inside.
 *
 * **It does not throw outside one**, unlike a scroll region's: everything here is something a
 * column can do without, so an item rendered bare is a plain div rather than a mistake.
 */
export const useResizableColumns = () => useContext(ResizableColumnsContext);
